module.exports = __webpack_public_path__ + "img/retreadbs.3efea711.webp";